import React from "react"

import { ProductLayout, Left, Right } from "./styles"

const FeaturedProductLayout = ({
  elRef,
  mediaElement,
  detailsElement,
  variant,
  dataId,
  hideOnPageLoad,
  ...props
}) => (
  <ProductLayout hideOnPageLoad={hideOnPageLoad} data-exp-id={dataId} ref={elRef} {...props}>
    <Left variant={variant}>{mediaElement}</Left>
    <Right variant={variant}>{detailsElement}</Right>
  </ProductLayout>
)

export default FeaturedProductLayout
